import api from './lib/api-factory';
import TOKEN from './lib/token';
export { TOKEN };

export { ENDPOINTS } from './lib/endpoints';
export default api;
